exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[tab]{font-size:0;border-bottom:1px solid #e6e6e6;border-top:1px solid #e6e6e6;height:5rem;line-height:5rem;-webkit-box-sizing:border-box;box-sizing:border-box}[tab]>*{display:inline-block;font-size:1rem;vertical-align:top}[tab] a{text-align:center;color:#666;-webkit-box-sizing:border-box;box-sizing:border-box;border-right:1px solid #e6e6e6;font-size:1.75rem;line-height:1.4;line-height:5rem}[tab] a:first-child{border-left:1px solid #e6e6e6}[tab] a.on,[tab] a.router-link-active{color:#333;font-weight:700;position:relative}[tab] a.on:after,[tab] a.router-link-active:after{content:\"\";display:block;position:absolute;left:0;bottom:1px;right:auto;top:auto;width:100%;height:3px;background:#d70539}[tab].col-2 a{width:50%}[tab].col-3 a{width:33.33%}[tab].col-4 a{width:25%}[tab].col-5 a{width:20%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-227ab268","scoped":false,"hasInlineConfig":false}!./node_modules/less-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/front/component/Tab.vue
// module id = YWLD
// module chunks = 241